module.exports = __webpack_public_path__ + "img/logo.65832a07.png";